import { ReactElement } from 'react';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';
import CustomTextField from '../base/CustomTextField';

/**
 * Prompt user for input: middle initial
 * @returns {ReactElement} textbox prompting for middle initial
 */
const MiddleInitial = () => {
	return (
		<CustomTextField
			name={NEW_NON_EMPLOYEE_KEYS.MIDDLE_INITIAL}
			label='Middle Initial'
		/>
	);
};
export default MiddleInitial;
